import { render } from "./OsdSchreiben.vue?vue&type=template&id=d7abe126&scoped=true"
import script from "./OsdSchreiben.vue?vue&type=script&lang=js"
export * from "./OsdSchreiben.vue?vue&type=script&lang=js"

import "./OsdSchreiben.vue?vue&type=style&index=0&id=d7abe126&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7abe126"]])

export default __exports__